// lifeDisplay.js — override d'affichage des PV pendant les animations de
// combat. Le serveur envoie l'état FINAL (tous les dégâts appliqués d'un
// coup) ; ce store permet à useCombatAnimations d'afficher les PV qui
// descendent attaque par attaque, puis de rendre la main à l'état réel.

const listeners = { player: new Set(), opponent: new Set() };
const values = { player: null, opponent: null };

export function setLifeDisplay(side, value) {
  if (!(side in values)) return;
  values[side] = value;
  listeners[side].forEach((cb) => cb(value));
}

export function clearLifeDisplay(side) {
  setLifeDisplay(side, null);
}

export function subscribeLifeDisplay(side, cb) {
  if (!(side in values)) return () => {};
  listeners[side].add(cb);
  cb(values[side]);
  return () => listeners[side].delete(cb);
}
